/** A unique symbol used as a key to store or reference the original price of an item. */
export const originalPriceKey: symbol = Symbol();
